
import Vue from 'vue'

const component = Vue.extend({
  props: {
    gap: {
      type: [Number, String],
      default: 6
    }
  }
})

Vue.component('AGapText', component)
export default component
